export default "__VITE_ASSET__CGpHrVxs__"